<app-modal>
  <ng-container class="title">
    <span class="text-uppercase">{{ questionnaire.name }}</span>
  </ng-container>
  <ng-container class="actions">
    <button type="button" class="button-tertiary" (click)="activeModal.dismiss()">
      {{ 'action.close' | transloco | uppercase }}
    </button>
  </ng-container>

  <ng-container class="content">
    <div class="d-flex flex-column row-gap-3">
      <div *ngFor="let section of questionnaire.sections">
        <div *ngIf="section.title" class="h2 fw-semibold mb-2">{{ section.title }}</div>

        <div class="d-flex flex-column gap-2">
          <div *ngFor="let question of section.questions"
               [ngClass]="{ 'required': question.required }">
            <label>{{ question.label }}</label>
            <span class="ms-4 fw-semibold"
                  (click)="question.type === QuestionType.IMAGE && question.answer ? open(question.answer.url) : null"
                  [ngClass]="{ 'btn-link text-truncate cursor-pointer': question.type === QuestionType.IMAGE && question.answer }">
              {{ question.type === QuestionType.IMAGE ? question.answer?.originalFileName : question.answer }}
            </span>
            <span *ngIf="question.image" (click)="open(question.image.url)"
                  [ngClass]="{ 'btn-link text-truncate cursor-pointer': question.image.url }">
              ({{ question.image.originalFileName }})
            </span>
          </div>
        </div>
      </div>
    </div>

    <p class="text-secondary mt-3">
      {{'mission.completedAt' | transloco}} {{ questionnaire.answerDateTime | datetime: {withTimezone: false} }}
    </p>
    <p *ngIf="completedByName | async as accountName" class="text-secondary mt-3">
      {{'mission.completedBy' | transloco}} {{ accountName }}
    </p>
  </ng-container>
</app-modal>
